import { Component, ElementRef, HostBinding, HostListener, Input, OnInit, ViewChild, inject, input } from '@angular/core';
import { FormControl, NgControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

/**
 * 'ngDefaultControl' and 'formControlName' must be provided to the component.
 *
 * Usage example:
 * @example
 * <app-ice-radio-button ngDefaultControl formControlName="myFormControlName" label="myLabel" forId="uniqueId" value="myValue" />
 */
@Component({
  selector: 'app-ice-radio-button',
  templateUrl: './ice-radio-button.component.html',
  styleUrl: './ice-radio-button.component.scss',
  imports: [FormsModule, ReactiveFormsModule],
})
export class IceRadioButtonComponent implements OnInit {
  private controlDirective = inject(NgControl);

  @Input({ required: true }) label: string;
  @Input({ required: true }) forId: string;
  @Input({ required: true }) value: string;
  @Input({ required: false }) disabled: boolean;
  @Input() isBoxVersion = false;
  testId = input.required<string>();

  @ViewChild('radio') radioInput: ElementRef;

  @HostBinding('class.radio-box') get class() {
    return this.isBoxVersion;
  }

  @HostListener('click') onClick() {
    if (this.control.disabled || this.disabled) return;

    this.control.setValue(this.value);
    this.radioInput.nativeElement.focus();
  }

  control: FormControl;

  ngOnInit() {
    this.control = this.controlDirective.control as FormControl;
  }
}
